import { Injectable, EventEmitter, Output } from '@angular/core';
import { SocialMediaPostForBoard} from '../../modele/boardModel';
import {Observable, of} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PostForBoardService {
    @Output() returnNewPost: EventEmitter<SocialMediaPostForBoard> = new EventEmitter();

  constructor() { }

  addNewPost(post_text, post_image, post_board_id, owner_name) {
      var today = new Date();
      var milliseconds = today.getMilliseconds();
      var seconds =  (milliseconds / 1000) % 60 ;
      let postContents = new SocialMediaPostForBoard(
          100,
          "whooosh",
          "mdi mdi-light mdi-24px mdi-facebook",
          owner_name,
          post_image,
          post_text,
          true,
          post_image,
          1,
          false,
          today,
          // ytContent.date,
          "0",
          "0",
          "0",
          seconds,

      );
      this.returnNewPost.emit(postContents)
  }

  public getNewPostEmitter(): EventEmitter<SocialMediaPostForBoard> {
         return this.returnNewPost;
  }
  timeConversion(duration: number) {
    const portions: string[] = [];

    const msInYear = 1000 * 60 * 60 * 24 * 365;
    const year = Math.trunc(duration / msInYear);
    if (year > 0) {
      portions.push(year + 'yrs');
      return portions

      duration = duration - (year * msInYear);

    }
    const msInDay = 1000 * 60 * 60 * 24;
    const days = Math.trunc(duration / msInDay);
    if (days > 0) {
      portions.push(days + 'd');
      return portions
      duration = duration - (days * msInDay);
    }

    const msInHour = 1000 * 60 * 60;
    const hours = Math.trunc(duration / msInHour);
    if (hours > 0) {
      portions.push(hours + 'hrs');
      return portions
      duration = duration - (hours * msInHour);
    }

    const msInMinute = 1000 * 60;
    const minutes = Math.trunc(duration / msInMinute);
    if (minutes > 0) {
      portions.push(minutes + 'min');
      return portions

      duration = duration - (minutes * msInMinute);
    }

    const seconds = Math.trunc(duration / 1000);
    if (seconds > 0) {
      portions.push(seconds + 'sec');
    }

    return portions.join(' ');
  }


}
